﻿const en = {
    application_title: 'Login',
    japanese: 'Japanese',
    english: 'English',
    french: 'French',
    german: 'German',
    italian: 'Italian',
    spanish: 'Spanish',
    language: 'Language',
    login_selectscreen: 'Select screen',
    login_all: 'All',
    login_executive: 'Executive',
    login_manager: 'Manager',
    login_operator: 'Operator',
    login_forgot_password: 'Forgot your password',
    user_id: 'User Name',
    user_password: 'Password',
    authorizer: 'Authorizer',
    authorizer_text: 'Note:\nPlease enter the e-mail address of the authorizer.\nThe authorizer must be a user with approval privileges.',
    sign_in: 'Login',
    sign_in_error: 'Wrong user name or password',
    create_account: 'Create New Account',
    forget_password_title: 'Please send a password reset request to the email address below.',
    forget_password_email: 'dashboard-u_support2@gcp.konicaminolta.com',
    forget_password_text: '・Please copy the text below, paste it into the subject line and send it by email.\n\
    >[Request] Password reset\n・You can leave the main message of the email blank.\n\
・Please send the e-mail from the e-mail address registered in this software.\n\
・We may not be able to respond to requests from unregistered email addresses.\n\
・If you do not receive a reply within 24 bussiness hours, please resend it.\n\
・Please note that your account will be deleted if you cannot confirm your login within one month of receiving this email.\n\
・Please confirm the notification of the new password from the following e-mail address.\n\
"no-reply@verificationemail.com"',
    forget_password_team: 'AccurioPro Dashboard Op-Analysis Operation Team',
    privacy_statement: 'Privacy Statement',
    privacy_statement_contents: 'At Konica Minolta Business Solutions Europe GmbH and its subsidiaries, sister companies and parent companies which are as listed in the attachment 1. (“Konica Minolta”), we take the issue of privacy seriously. This Privacy Policy provides information about the ways in which we collect, use, disclose and otherwise manage personal data. \n\n\
Who is the Data Controller? \n\
Konica Minolta will use your personal data mentioned below. \n\n\
What information do we collect about you? \n\
Konica Minolta collects your e-mail address. \n\n\
How will your information be used? \n\
Konica Minolta uses your information above only for the purpose below: \n\
Identification and; \n\
contact for providing necessary information on AccurioPro Dashboard. \n\n\
What is our legal basis for processing your personal data? \n\
Legitimate interest is legal basis for processing. \n\
Legitimate Interests are a) identification, and b) contact for providing necessary information on AccurioPro Dashboard. \n\n\
Who receives your information? \n\
Your personal data above will be treated as strict confidential, and will not be shared with any third party without your prior consent. \n\n\
Storage period \n\
Konica Minolta will process personal data during the duration of your need to use AccurioPro Dashboard for your assignment and will continue to store only the personal data needed for three months after your assignment is changed or you leave the company (“Change”). During deletion period from the Change to three months from the Change, any personal data not needed will be deleted because Konica Minolta delete personal data which are not needed per quarter. \n\n\
Data storage and transfer of data \n\
Data is stored in Germany. For identification and contact, Konica Minolta, Inc. is involved..  Japan is a country which ensures adequate level of protection of personal data decided by European Commission. \n\n\
What are your rights under GDPR? \n\
Whilst Konica Minolta is in possession of or processing your personal data, you have the following rights: \n\
Right of access – you have the right to request a copy of the information that we hold about you. \n\
Right of rectification – you have a right to correct data that we hold about you that is inaccurate or incomplete. \n\
Right to be forgotten – in certain circumstances you can ask for the data we hold about you to be erased from our records. \n\
Right to restriction of processing – where certain conditions apply to have a right to restrict the processing. \n\
Right of portability – you have the right to have the data we hold about you transferred to another organisation. \n\
Right to object – you have the right to object to certain types of processing such as direct marketing. \n\
Right to object to automated processing, including profiling – you also have the right to be subject to the legal effects of automated processing or profiling. \n\
In the event that Konica Minolta refuses your request under rights of access, we will provide you with a reasonable explanation. \n\
If you exert any of your rights, please send e-mail to dashboard-u_support1@gcp.konicaminolta.com. \n\n\
Contact details of the Data Controller \n\
You are welcome to contact our company at any time if you have any questions relating to the topic of data privacy. The contact details of other companies are mentioned in the Attachment.2. \n\n\
Konica Minolta Business Solutions Europe GmbH \n\
Europaallee 17 \n\
30855 Langenhagen \n\
Germany \n\
dashboard-u_support1@gcp.konicaminolta.com \n\n\
Contact details of Data Protection Officer \n\
You are welcome to contact our company data privacy officer at any time if you have any questions relating to the topic of data privacy. \n\
This person is \n\
Dr. Frederike Rehker \n\
Konica Minolta Business Solutions Europe GmbH \n\
Europaallee 17 \n\
30855 Langenhagen \n\
Germany Telephone: +49 (0)511 7404-0 \n\
E-Mail: dataprotection(at)konicaminolta.eu \n\n\
Attachment.1 \n\n\
Konica Minolta Business Solutions Deutschland GmbH, \n\
Konica Minolta Business Solutions France S.A.S., \n\
Konica Minolta Business Solutions (UK) Limited, \n\
Konica Minolta Business Solutions Romania s.r.l., \n\
Konica Minolta Business Solutions Italia S.p.A., \n\
Konica Minolta Business Solutions Nederland B.V., \n\
Konica Minolta Business Solutions Greece S.A., \n\
Konica Minolta Business Solutions Czech spol. s r.o., \n\
Konica Minolta Hungary Business Solutions Ltd., \n\
Konica Minolta Business Solutions Polska Sp.z.o.o., \n\
Konica Minolta Business Solutions Bulgaria EOOD, \n\
Konica Minolta Business Solutions Slovenia d.o.o., \n\
Konica Minolta Croatia-Business Solutions d.o.o., \n\
Konica Minolta Slovakia spol. s.r.o., \n\
Konica Minolta Baltia UAB, \n\
Konica Minolta Business Solutions Denmark A/S, \n\
Konica Minolta Business Solutions Spain S.A., \n\
Konica Minolta Business Solutions Sweden AB, \n\
Konica Minolta Business Solutions Norway AS, \n\
Konica Minolta Business Solutions (Belgium) N.V., \n\
Konica Minolta Business Solutions Austria GmbH, \n\
Konica Minolta Business Solutions Portugal, Unipessoal Lda., \n\
Konica Minolta Business Solutions Finland Oy, and \n\
Konica Minolta, Inc., which is located at 2-7-2, Marunouchi, Chiyoda-ku, Tokyo, Japan \n\n\
Attachment.2 \n\n\
Konica Minolta Business Solutions Deutschland GmbH \n\
Europaallee 17, 30855 Langenhagen, Germany \n\
dashboard-u_support1@gcp.konicaminolta.com \n\n\
Konica Minolta Business Solutions France S.A.S. \n\
365-367 Route de Saint-Germain, F-78424 Carrieres-sur-Seine, France \n\
dashboard-u_support1@gcp.konicaminolta.com \n\n\
Konica Minolta Business Solutions (UK) Limited \n\
Miles Gray Road,Basildon,Essex,SS14 3AR., U.K. \n\
dashboard-u_support1@gcp.konicaminolta.com \n\n\
Konica Minolta Business Solutions Romania s.r.l. \n\
Str. Copilului nr. 18, parter, sector 1, 012178 Bucharest, Romania \n\
dashboard-u_support1@gcp.konicaminolta.com \n\n\
Konica Minolta Business Solutions Italia S.p.A. \n\
Viale Certosa, 144, 20156 Milano, Italy \n\
dashboard-u_support1@gcp.konicaminolta.com \n\n\
Konica Minolta Business Solutions Nederland B.V. \n\
Hoogoorddreef 9, Postbus 22110, 1100 CC Amsterdam, The Nederland \n\
dashboard-u_support1@gcp.konicaminolta.com \n\n\
Konica Minolta Business Solutions Greece S.A. \n\
3, Messologiou Str., GR-14451 Metamorphosis, Athens, Greece \n\
dashboard-u_support1@gcp.konicaminolta.com \n\n\
Konica Minolta Business Solutions Czech spol. s r.o. \n\
Brno - Židenice, Žarošická 4395/13, PSČ 628 00, Czech Republic \n\
dashboard-u_support1@gcp.konicaminolta.com \n\n\
Konica Minolta Hungary Business Solutions Ltd. \n\
Galvani u. 4., 1117 Budapest, Hungary \n\
dashboard-u_support1@gcp.konicaminolta.com \n\n\
Konica Minolta Business Solutions Polska Sp.z.o.o. \n\
Muszkieterów 15, 02-273 Warszawa, Poland \n\
dashboard-u_support1@gcp.konicaminolta.com \n\n\
Konica Minolta Business Solutions Bulgaria EOOD \n\
Biznes park Sofia 7, 1715 Sofia, Bulgaria \n\
dashboard-u_support1@gcp.konicaminolta.com \n\n\
Konica Minolta Business Solutions Slovenia d.o.o. \n\
Vodovodna cesta 101, 1000 Ljubljana, Slovenia \n\
dashboard-u_support1@gcp.konicaminolta.com \n\n\
Konica Minolta Croatia-Business Solutions d.o.o. \n\
Radnicka cesta 1a, HR-10000 Zagreb, Croatia \n\
dashboard-u_support1@gcp.konicaminolta.com \n\n\
Konica Minolta Slovakia spol. s.r.o. \n\
Cernysevskeho 10, 85101 Bratislava, Slovak Republic \n\
dashboard-u_support1@gcp.konicaminolta.com \n\n\
Konica Minolta Baltia UAB \n\
J. Jasinskio str. 16, LT2001 Vilnius, Lithuania \n\
dashboard-u_support1@gcp.konicaminolta.com \n\n\
Konica Minolta Business Solutions Denmark A/S \n\
Lautrupvang 2B, 2750 Ballerup, Denmark \n\
dashboard-u_support1@gcp.konicaminolta.com \n\n\
Konica Minolta Business Solutions Spain S.A. \n\
C/ Albasanz, 12, 28037 Madrid, Spain \n\
dashboard-u_support1@gcp.konicaminolta.com \n\n\
Konica Minolta Business Solutions Sweden AB \n\
Kronborgsgränd 19, S-164 46 Kista, Sweden or P.O. Box 1125, S-164 22 Kista, Sweden \n\
dashboard-u_support1@gcp.konicaminolta.com \n\n\
Konica Minolta Business Solutions Norway AS \n\
Maridalsveien 323, 0872 Oslo, Norway \n\
dashboard-u_support1@gcp.konicaminolta.com \n\n\
Konica Minolta Business Solutions (Belgium) N.V. \n\
Excelsiorlaan 10, 1930 Zaventem, Belgium \n\
dashboard-u_support1@gcp.konicaminolta.com \n\n\
Konica Minolta Business Solutions Austria GmbH \n\
Amalienstrasse 59-61, A-1131 Vienna, Austria \n\
dashboard-u_support1@gcp.konicaminolta.com \n\n\
Konica Minolta Business Solutions Portugal, Unipessoal Lda. \n\
Rua Professor Henrique de Barros nº 4, 10º B 2685-338 Prior Velho, Portugal \n\
dashboard-u_support1@gcp.konicaminolta.com \n\n\
Konica Minolta Business Solutions Finland Oy \n\
Keilaranta 10 E, 02150 Espoo, Finland \n\
dashboard-u_support1@gcp.konicaminolta.com \n\n\
Konica Minolta, Inc. \n\
2-7-2 Marunouchi, Chiyoda-ku, Tokyo, \n\
Japan \n\
dashboard-u_support1@gcp.konicaminolta.com',
    register: 'Register',
    update: 'Update',
    email: 'e-mail address',
    fields_compulsory: 'All fields are compulsory.\n',
    authorizer_email_error: 'Invalid authorizer e-mail address.\n\n',
    email_error: 'Invalid e-mail address.\n',
    username_error: 'Only alphanumeric characters can be entered for the user name.\n',
    serial_number_duplicate_error: 'The serialnumbers are duplicated.\n',
    password_match_error: 'Passwords do not match.\n',
    not_km_domain: 'Authorizer e-mail address domain is not konicaminolta domain.\n\',   ',
    registered: 'Registered!!',
    add_account_email_text: 'Dear {authorizer},%0D%0A%0D%0A\n{email} have created ones\'s account of AccurioPro Dashboard Op-Analysis.%0D%0A%0D%0A\n\
Anyone who is not a member of Konica Minolta can use this application with approval by a Konica Minolta user.%0D%0A\n\
So please log in to the URL below and approve it.%0D%0A%0D%0A\n\
URL %0D%0A\n\
{url} %0D%0A%0D%0A\n\n\
Kind regards,%0D%0A\n\
Konica Minolta Inc.%0D%0A\n\n\
',
    customer_email_text: 'Dear {email},%0D%0A%0D%0A\
We have created your account for Printer Performance Analysis tool.%0D%0APlease log in to the URL below.%0D%0A\
URL: https://dashboard-u.konicaminolta.com%0D%0A\
user name: {userId}%0D%0A\
password: {password}%0D%0A%0D%0A\
You can use all the functions of this application after input Product Key in License setting feature.%0D%0A\
*The Product Key will be sent you by e-mail separately. Please be sure to that.%0D%0A%0D%0A\
Kind regards,%0D%0AKonica Minolta Inc.',
    request_to_you: 'You have the authority to approve or deny the CE account creation request.',
    http_get_error: '{status}: Processing failed. Return to login screen.',
    server_error: 'Internal server error.',
    http_connection_error: 'Not connected to the internet.',
    ce_top_title: 'Select the customer you want to log in to.',
    add_customers_account: 'Add customer\'s account',
    go_back: 'Cancel',
    customers: 'Your Customers Name',
    serial_numbers: 'Serial numbers registered',
    open: 'Open',
    add_sn: 'Add printer\'s serial number',
    add_ce: 'Add CE to follow this customer',
    printers_sn: 'Printer\'s serial number',
    edit_customer_title: 'Edit customer registeration',
    customer_email_address: 'Customer e-mail address',
    license: 'License',
    printers_registered: 'Printers registered',
    serial_number: 'Serial number',
    latest_data: 'Latest data',
    persons_in_charge: 'Persons in charge',
    customer_engineer: 'Customer Engineer',
    sender: 'From',
    authorization: 'Authorization',
    approve: 'Approve',
    do_not_approve: 'Not Approve',
    request_approved: 'Request Approved!',
    request_disapproved: 'Request Disapproved!',
    approved: 'Approved',
    do_not_approved: 'Rejected',
    processed_result: 'Processed Result',
    processed_date: 'Processed Date',
    header_nfr: 'Not for resale license (NFR)',
    header_recommendation: 'Recommendation',
    header_previous: 'Previous',
    header_next: 'Next',
    header_reset: 'Reset',
    header_change_password: 'Change password',
    header_settingMenu_tutorial: 'Tutorial',
    header_old_password: 'Current password',
    header_new_password: 'New password',
    header_confirm_password: 'New password(Confirm)',
    header_cancel: 'Cancel',
    header_apply: 'Apply',
    header_ok: 'OK',
    header_close: 'Close',
    from: 'From',
    to: 'To',
    change_date_heading: 'Range setting',
    change_date_explanation: 'Please set the target date range for CSV export',
    header_password_explanation: 'Please create a password with string of 8 or more characters including uppercase and lowercase letters and numbers.',
    header_machine_setting: 'Machine setting',
    header_machine_setting_title: 'You can change the machine display order by drag and drop.',
    header_machine_setting_notes: 'Machine setting',
    header_machine_setting_model: 'Model : ',
    header_machine_setting_serial_number: 'S/N : ',
    header_machine_setting_machine_name: 'Machine Name : ',
    header_machine_setting_error_message_max_length: 'Please input 64 characters or less.',
    header_machine_setting_error_message_min_length: 'Please input the machine name.',
    header_machine_setting_error_message_common: 'Please check the machine name contents.',
    header_machine_setting_complete_message: 'Update is completed. Reload the display.',
    header_lms_setting: 'License setting',
    header_lms_explanation: 'Enter the Product Key notified by email, press the "refer" button, and then press the "activate" button.',
    header_lms_add: 'Add',
    header_lms_delete: 'Delete',
    header_lms_pkIdTitle: 'Product Key',
    header_lms_refer: 'refer',
    header_lms_licenseKind: 'license type',
    header_lms_licenseDate: 'license available',
    header_lms_licenseState: 'activate state',
    header_lms_activate: 'activate',
    header_lms_deactivate: 'deactivate',
    header_lms_state_activate: 'Activate',
    header_lms_state_deactivate: 'Deactivate',
    header_lms_ptl_date: 'Test license will expire on',
    header_lms_activationDate: 'Activation available',
    header_lms_never_expired: 'Never Expired',
    header_users_guide: 'User\'s guide',
    header_users_guide_link: 'https://www.btapac.konicaminolta.com/users_guide/accuriopress_C14000_series/3_0_0/en/index.html',
    header_version_info: 'Version',
    screen1_productivity_rate: 'Productivity rate',
    screen1_productivity_pred: 'Productivity Prediction',
    screen1_week_before_last_availability: 'Week before last',
    screen1_productivity_diff: 'Actual difference',
    screen1_week_before_last_pred_diff: 'Difference between the previous week\'s forecast and the actual development',
    screen1_productivity_a4_tips: 'Productivity is converted to A4 size',
    screen1_productivity_a3_tips: 'Productivity is converted to A3 size',
    screen1_results_of_production: 'Results of production',
    screen1_est_print_time: 'Pred. Print time(hh:mm)',
    screen1_act_print_time: 'Act. Print time(hh:mm)',
    screen1_gap: 'Gap (hh:mm)',
    screen1_sheets: '#of prints',
    screen1_sheets_per_h: '#of prints/hour',
    screen1_availability: 'Availability (%)',
    screen1_job_list_link: 'Job list',
    screen1_machine_list_link: 'Machine list',
    top_manager_title_production_result: 'Total',
    top_manager_title_prints: 'Prints',
    top_manager_title_errors: 'Errors',
    top_manager_jobs: 'Jobs',
    top_manager_color_pv: 'Color Pages',
    top_manager_bw_pv: 'B/W Pages',
    top_manager_output_paper: 'Output papers ',
    top_manager_trayfull_count: 'Tray full',
    top_manager_paperjams__count: 'Paper jams',
    top_manager_servicecall_count: 'Service call',
    top_manager_paperempty_count: 'Paper empty',
    top_manager_tonerempty_count: 'Toner empty',
    top_operator_title_production_result: 'History of machine operation',
    top_operator_title_trouble_result: 'Total',
    top_operator_subtitle_output_paper_result: 'Trend of Output paper count',
    top_operator_subtitle_output_availability_result: 'Machine availability',
    top_operator_paper_count: 'Result of output paper count',
    top_operator_subtitle_output_paper_count: 'Output paper count(sheets)',
    top_operator_subtitle_interruption_result: 'Interruption results (min)',
    top_operator_trayfull: 'Tray full',
    top_operator_paperempty: 'Paper empty',
    top_operator_tonerempty: 'Toner empty',
    top_operator_paperjams: 'Paper jams',
    top_operator_servicecall: 'Service call',
    top_operator_explanation_worst1: 'Worst stop factor ',
    top_operator_explanation_worst2: '2nd ',
    top_operator_explanation_worst3: '3rd ',
    screen3_print_hours: 'hrs',
    listofprintjobs_title: 'Job list',
    listofprintjobs_number: 'No.',
    listofprintjobs_start_time: 'Start time',
    listofprintjobs_job_id: 'Job ID',
    listofprintjobs_pages_set: 'Pages/<br>Set',
    listofprintjobs_output_set: 'Output<br>sets',
    listofprintjobs_exit_count: 'Output paper Count',
    listofprintjobs_machine_name: 'Machine',
    jobdetail_left_title: 'Job Details',
    jobdetail_timeline_title: 'Output Timeline',
    jobdetail_job_id: 'Job ID',
    jobdetail_size: 'Paper size',
    jobdetail_paper_kind: 'Paper type',
    jobdetail_paper_weight: 'Paper weight/Thickness',
    jobdetail_color: 'Mono/Color',
    jobdetail_side: 'Single-sided/Duplex',
    jobdetail_pages: 'Pages/Set',
    jobdetail_unit_pages: 'Pages',
    jobdetail_units: 'Output sets',
    jobdetail_unit_units: 'number of sets',
    jobdetail_sheets: 'Output paper count',
    jobdetail_unit_sheets: 'sheets',
    jobdetail_center_title: 'Machine',
    jobdetail_machine_name: 'Machine name',
    jobdetail_tray_full: 'Tray full',
    jobdetail_paper_empty: 'Paper empty',
    jobdetail_toner_empty: 'Toner empty',
    jobdetail_paper_jam: 'Paper jams',
    jobdetail_service_call: 'Service call',
    jobdetail_panel_operation: 'Operation Panel',
    jobdetail_frontdoor_open: 'Front Door',
    jobdetail_tray_open: 'Paper Feed Tray',
    jobdetail_right_title: 'Difference between predicted and actual print time',
    jobdetail_graph_x_title: 'Pred. Print time[min]',
    jobdetail_graph_y_title: 'Act. Print time[min]',
    jobdetail_legend_jobs: 'Job output in {machineName}',
    jobdetail_legend_target: 'This print job',
    jobdetail_tooltip_jobid: 'Job ID: ',
    jobdetail_tooltip_diff: 'Difference: ',
    jobdetail_tooltip_actual: 'Actual print time: ',
    jobdetail_tooltip_assumed: 'Assumed print time: ',
    jobdetail_start_time: 'start time',
    jobdetail_end_time: 'end time',
    availabilitydetail_left_title: 'Machine list',
    availabilitydetail_center_title: 'Difference between machines',
    availabilitydetail_right_title: 'Trend of Printing Time by machine',
    availabilibydetail_unit_hour: 'hrs',
    availabilibydetail_machine: 'Machine',
    availabilibydetail_unit_idle: 'Idle',
    availabilibydetail_unit_interruption: 'Print interruption',
    availabilibydetail_unit_preparation: 'Print preparation',
    availabilibydetail_unit_printing: 'Printing',
    joblist_title: 'Job list',
    joblist_number: 'No.',
    joblist_estprinttime: 'Pred. Print time(hh:mm)',
    joblist_actprinttime: 'Act. Print time(hh:mm)',
    joblist_hourlyunits: 'Hourly output of pages',
    joblist_printcompletedtime: 'Printing time (hh:mm)',
    joblist_printtimediff: 'Gap (hh:mm)',
    joblist_csv_export: 'CSV Export',
    joblist_est_hourlyunits: 'Pred. pages per hour',
    joblist_est_printcompletedtime: 'Pred. Printing time (hh:mm)',
    joblist_act_hourlyunits: 'Act. pages per hour',
    joblist_act_printcompletedtime: 'Act. Printing time (hh:mm)',
    proddetail_title: 'Prediction Gap of Printing time',
    proddetail_table_title: 'Production Volume Trends',
    proddetail_graph_yaxis_left: 'Printing time (hh:mm)',
    proddetail_graph_yaxis_right: 'Achievement Rate(%)',
    proddetail_est_print_time: 'Pred. Print time',
    proddetail_act_print_time: 'Act. Print time',
    proddetail_gap: 'Gap (hh:mm)',
    proddetail_duration_daily: 'daily',
    proddetail_duration_weekly: 'weekly',
    proddetail_duration_monthly: 'monthly',
    machinedetail_left_title: 'Machine details',
    machinedetail_center_title: 'Errors',
    machinedetail_right_title: 'Machine available details',
    machinedetail_availability: 'Availability',
    machinedetail_operating_time: 'Operating time(hrs)',
    machinedetail_printing_time: 'Printing time(hrs)',
    machinedetail_output_set: 'Output sets',
    machinedetail_output_paper: 'Output paper count',
    machinedetail_power_on: 'Power ON',
    machinedetail_power_off: 'Power OFF',
    common_min_per_week: 'min/week',
    common_2days_ago: 'day before yesterday',
    common_yesterday: 'yesterday',
    common_today: 'today',
    common_tomorrow: 'tomorrow',
    common_2days_after: 'day after tomorrow',
    common_2weeks_ago: '2 weeks ago',
    common_last_week: 'Last week',
    common_this_week: 'this week',
    common_next_week: 'next week',
    common_2weeks_after: 'week after next',
    common_2months_ago: '2 months ago',
    common_last_month: 'last month',
    common_this_month: 'this month',
    common_next_month: 'next month',
    common_2months_after: 'month after next',
    common_days_ago: '{dateNum} days ago',
    common_weeks_ago: '{dateNum} weeks ago',
    common_months_ago: '{dateNum} months ago',
    common_days_after: '{dateNum} days after',
    common_weeks_after: '{dateNum} weeks after',
    common_months_after: '{dateNum} months after',
    common_mins: 'min',
    common_hours: 'hrs',
    common_date: 'Date',
    common_percentage: '%',
    icon_recommendation: 'Recommendation',
    icon_analysis: 'Analysis',
    icon_operation: 'Operation',
    icon_machine: 'Machine',
    icon_material: 'Material',
    icon_method: 'Method',
    icon_running_time: 'Running Time',
    icon_preparation_time: 'Preparation Time',
    icon_downtime: 'Downtime',
    paperEmpty: 'Paper empty',
    tonerEmpty: 'tonerEmpty',
    trayFull: 'trayFull',
    Total: 'Total',
    Average: 'AVE.',
    hour_unit: 'h',
    date_format: 'DD.MM.YY',
    date_format2: 'DD.MM',
    month_format: 'MM.YY',
    errCode_10000: 'Password change failed.',
    errCode_10001: 'New password and New password (Confirm) do not match.',
    errCode_10002: 'Password must be a character string of at least 8 characters including uppercase and lowercase letters and numbers.',
    errCode_10003: 'Please wait about 10 minutes and then change your password again.',
    errCode_10004: 'Current password is incorrect.',
    errCode_10005: 'Your session is expired. Please login again.',
    errCode_10006: 'Network error has occurred.',
    errCode_10100: 'An error has occurred. Please contact the administrator.',
    errCode_10101: 'Please enter Product Key.',
    errCode_10102: 'Failed to get the Product Key information.',
    errCode_10103: 'Activation failed.',
    errCode_10104: 'Deactivation failed.',
    errCode_10105: 'Failed to delete the Product Key information.',
    errCode_10106: 'Cannot set the same Product Key.',
    errCode_10007: 'Please check the verification email and login from the link in the email body.',
    errCode_20000: 'Parameter is invalid.',
    errCode_20001: 'Specified mail address already exists.',
    errCode_20002: 'Specified user name already exists.please specify another user name.',
    errCode_20003: 'Specified user name is not registered as a customer.',
    suggestion_overview: 'Overview',
    suggestion_pgap_overview_good: 'Prediction Gap has decreased',
    suggestion_pgap_overview_bad: 'Prediction Gap has increased',
    suggestion_pgap_overview_even: 'Prediction Gap has not changed',
    suggestion_ma_overview_good: 'Availability rate has increased',
    suggestion_ma_overview_bad: 'Availability rate has decreased',
    suggestion_ma_overview_even: 'Availability rate has not changed',
    suggestion_attention_machine: 'machine requires attention: ',
    suggestion_tips: 'Tips',
    suggestion_pv_up: 'Print volume increased',
    suggestion_pv_down: 'PV is down',
    suggestion_pv_even: 'Print volume has not changed',
    suggestion_downtime_long: 'More downtime',
    suggestion_smalljob_many: 'Small lots jobs increased',
    suggestion_efficiency_up: 'Production efficiency has increased',
    ce_login_tutorial: 'Refer to the tutorial for introduction',
    ce_dialog_header_confirm: 'Confirmation',
    ce_confirmation_message: 'Are you really want to update the customer details?',
    ce_email_confirmation: 'The customer\'s password initialization email will be created. Are you sure?',
    username_email: 'User Name (e-mail address)',
    ce_dialog_header_info: 'Information',
    ce_account_complete_kmce: 'The account registration has been completed. Go to the login screen.',
    ce_account_complete_dealer: 'The account registration request has been completed. Please wait until approved.',
    ce_user_account_complete_kmce: 'The account registration has been completed.',
    ce_user_account_complete_dealer: 'The account registration request has been completed. Please wait until approved.',
    ce_error_400: 'There is an error in the edited content. Please check the contents.',
    ce_error_409: 'Re-acquire information because it has been updated by another user',
    ce_top_operator_user_name: '{userName}\'s top operator screen',
    add_new_customer: 'Add new customer',
    add_existed_customer: 'Add existed customer',
    ce_edit_licenseExpiresOn: 'Expires on',
    send_mail: 'Mail sent successful.',
    password_change_complete: 'Password change completed.',
    reset_password: 'Password reset',
    change_button: 'change',
    send_button: 'send',
    common_error_500: 'Failed to process.',
    error_send_mail: 'Failed to send the mail.',
    error_confirm_password_incorrect: 'The password and the confirmation password are different.',
    error_usename_not_exist: 'The specified username does not exist.',
    error_id_not_exist: 'The specified id does not exist.',
    error_id_mailaddress_not_exist: 'The specified id or email address does not exist.',
    ce_forget_password_dialog_message: 'Send a password change email.Please change your password from the URL described in the body of the email.',
    user_forget_password_dialog_message: 'Please confirm again if you want to change it as it will affect all members who use this account. The email including new password will be sent to you, so please login with the password given in the body of the email. If you do not know your e-mail address, please contact the CE in charge.',
    Mon: 'Mon',
    Tue: 'Tue',
    Wed: 'Wed',
    Thu: 'Thu',
    Fri: 'Fri',
    Sat: 'Sat',
    Sun: 'Sun',
    header_pending_verification: 'Pending verification',
    pending_verification_dialog_message: 'account is locked because the account is not used for long. Do you need to send confirmation e-mail?',
    trial_license_expired_message: 'Trial license is expired. Please input product key',
    errCode_20004: 'invalid URL',
    error_code: 'Malfuntion code',
    jam_location: 'Jam location',
    device_time: 'Occurrence Time',
    machine_name: 'Machine',
    paperJamsList_title: 'List of paper jams',
    error_support: 'Solution',
    error_describe: 'Error detail',
    serviceCallList_title: 'List of Service call',
    tray: 'Input Tray/Feeder',
    paperEmptyList_title: 'List of paper empty',
    output_tray_name: 'Output tray',
    trayFullList_title: 'List of tray full',
    tonerEmptyList_title: 'List of toner empty',
    toner_color: 'Toner color',
    errorCount_tip: 'The list was suspended because of analysis or number restriction',
    solve_time: 'Resolved Time',
    change_language: 'Change Language',
    machine_tab: 'Basic',
    custom_group_tab: 'Custom',
    group_name: 'Group name',
    group_checkbox_tip: 'Checked group will be selectable on UI',
    group_edit_tip: 'You can add a custom set of machine display.',
    custom_group: 'Custom group',
    group_comment: 'Comment',
    machine_checkbox_tip: 'Checked machine will be displayed when the group is selected',
    group_name_exits: 'The specified group name already exists.',
    header_group_name_max_length: 'Please input 64 characters or less.',
    header_group_name_min_length: 'Please input the group name.',
    header_group_comment_max_length: 'Please input 128 characters or less.',
    header_device_group_switch: 'Device group:',
    header_group_all: 'All(Sheet)',
    header_group_color: 'Color',
    header_group_monochrome: 'BW',
    header_group_detail_length: 'At least one machine must be selected in custom group.',
    header_group_select_tip: 'There is no machine in selected group. Register machine to the group.',
    group_name_specialchar_tip: 'Special character @ cannot be entered',
    change_date_heading_week: 'Week selector',
    machine_time_line: 'Timeline',
    header_group_ppall: 'AccurioPress/Print',
    header_group_km1: 'AccurioJet',
    top_manager_otherTransporterror_count: 'Transport section error',
    otherTransportErrorList_title: 'List of transport section error',
    jobdetail_otherTransporterror: 'Transport section error',
    top_operator_otherTransporterror: 'Transport section error',
    errCode_10008: 'The key is wrong or expired.',
    feeder: 'Feeder',
    license_expired_message: 'Your license is expired',
    logout_dialog_msg: 'All features would be available after  license activation.',
    header_logout_yes: 'Logout',
    header_logout_no: 'Cancel',
    paper_weight: 'Paper weight',
    paper_thickness: 'Thickness',
    errCode_10009: 'The SN is not registered.',
    errCode_10010: 'Login required',
    errCode_10011: 'No device registered',
    ce_reset_password_dialog_title: 'Customer account information notification',
    ce_reset_password_dialog_ultimate: 'Op-Analysis Ultimate',
    ce_reset_password_dialog_job_manager: 'Reset JobManager',
    ce_reset_password_dialog_all: 'Reset Both',
    ce_reset_password_dialog_job_manager_schedule: 'Reset New JobManager',
    customer_email_text_job_manager: 'Dear {email},%0D%0A%0D%0A\
We have created your account for AccurioPro Dashboard JobManager.%0D%0APlease log in to the URL below.%0D%0A\
URL: https://dashboard-jm.konicaminolta.com%0D%0A\
user name: {userId}%0D%0A\
Operator ID: administrator%0D%0A\
password: {password}%0D%0A%0D%0A\
You can use all the functions of this application after input Product Key in License setting feature.%0D%0A\
*The Product Key will be sent you by e-mail separately. Please be sure to that.%0D%0A%0D%0A\
This tutorial provides a convenient tutorial to make use of the accuriopro dashboard jobmanager.%0D%0A%0D%0A\
URL: https://dashboard-jm-tutorial.konicaminolta.com%0D%0A%0D%0A\
Kind regards,%0D%0AKonica Minolta Inc.',
    customer_email_text_all: 'Dear {email},%0D%0A%0D%0A\
We have created your account for AccurioPro Dashboard JobManager and Printer Performance Analysis tool.%0D%0APlease log in to the URL below.%0D%0A\
URL: https://dashboard-u.konicaminolta.com%0D%0A\
user name: {ultimateUserId}%0D%0A\
Operator ID: administrator%0D%0A\
JobManager password: {jobManagerPassword}%0D%0A\
Analysis password: {ultimatePassword}%0D%0A%0D%0A\
You can use all the functions of this application after input Product Key in License setting feature.%0D%0A\
*The Product Key will be sent you by e-mail separately. Please be sure to that.%0D%0A%0D%0A\
Kind regards,%0D%0AKonica Minolta Inc.',
    customer_email_text_with_flux_webhook: 'Dear {email},%0D%0A%0D%0A\
We have created your account for AccurioPro Dashboard JobManager.%0D%0APlease log in to the URL below.%0D%0A\
URL: https://dashboard-jm.konicaminolta.com%0D%0A\
user name: {userId}%0D%0A\
Operator ID: administrator%0D%0A\
password: {password}%0D%0A%0D%0A\
You can use all the functions of this application after input Product Key in License setting feature.%0D%0A\
*The Product Key will be sent you by e-mail separately. Please be sure to that.%0D%0A%0D%0A\
This tutorial provides a convenient tutorial to make use of the accuriopro dashboard jobmanager.%0D%0A%0D%0A\
URL: https://dashboard-jm-tutorial.konicaminolta.com%0D%0A\
Flux Integration Endpoint URL：{webhookUrl}%0D%0A%0D%0A\
Kind regards,%0D%0AKonica Minolta Inc.',
    TZ_0000: 'Europe/West/GB, PT (+0)',
    TZ_0100: 'Europe/Central/FR, DE (+1)',
    TZ_0200: 'Europe/East/UA, GR (+2)',
    TZ_0300: 'Europe/East/TR, Moscow (+3)',
    TZ_0630: 'Asia/India (+5.5)',
    TZ_0700: 'Asia/Viet Nam (+7)',
    TZ_0800: 'Asia/China (+8)',
    TZ_0900: 'Asia/Japan, Korea (+9)',
    TZ_1400: 'Pacific/Hawaii (-10)',
    TZ_1500: 'America/Alaska (-9)',
    TZ_1600: 'America/West/Los Angeles (-8)',
    TZ_1700: 'America/Mountain/Denver (-7)',
    TZ_1800: 'America/Central/Chicago (-6)',
    TZ_1900: 'America/East/New York (-5)',
    TZ_2100: 'South America/Sao Paulo (-3)',
    time_zone_title: 'Timezone',
    local_time: 'LocalTime',
    header_user_id: 'User Name',
    ce_customers_list_title: 'Customers List',
    ultimate_license_expires_on: 'Op-Analysis (expiration date)',
    jm_license_expires_on: 'Job Manager (expiration date)',
    jm_is_include_schedule: 'Schedule',
    ce_customers_list_search: 'search',
    ce_edit_registered: 'Registered',
    ce_edit_serialNumber: 'Serial number (printing machine)',
    ce_edit_lastUpdatedDate: 'Last updated date',
    ce_edit_responsibleCE: 'Responsible customer engineer',
    ce_edit_customerInfo: 'Customer Information',
    ce_edit_utimate: 'Op-Analysis',
    ce_edit_addSerialNumber: 'Add serial number',
    ce_edit_jobManager: 'Job Manager',
    ce_edit_commonInfo: 'Common information',
    ce_header_editCustomers: 'Edit customer',
    ce_add_addCustomers_title: 'You can add a new customer account',
    ce_serial_number_list: 'Serial number',
    ce_essential_link_file: 'Essential Linked file',
    ce_location_on_off: 'Beta features on / off',
    date: 'Date',
    before_suggistion: 'Original suggestion text',
    after_suggestion: 'Suggestion to be updated',
    batch_edit: 'Bulk update',
    data_error: 'The data has been updated. Please refresh and save again.',
    edit_suggestion: 'Edit Suggestion',
    suggestion: 'Suggestion',
    user_suggestion_list: 'Suggestion list',
    delete_suggestion: 'Delete',
    top_operator_adjustment: 'Maintenance',
    color: 'color',
    monochrome: 'Mono',
    duplex: 'Duplex',
    simplex: 'Single-sided',
    undefined_paper: 'None',
    normal_paper: 'Normal Paper',
    colored_paper: 'Colored Paper',
    high_quality_paper: 'High Quality Paper',
    color_paper: 'Color Paper',
    coated_gloss_laser_paper: 'Coated Paper-G',
    coated_mat_laser_paper: 'Coated Paper-M',
    coated_gloss_offset_paper: 'Coated Offset Paper-G',
    coated_mat_offset_paper: 'Coated Offset Paper-M',
    embossing_paper: 'Embossing Paper',
    envelope: 'Envelope',
    rough_paper: 'Rough Paper',
    book_paper: 'Book Paper',
    coated_paper: 'Coated Paper',
    preprinted_paper: 'Preprinted Paper',
    blank_insert_paper: 'Blank Insert Paper',
    generate_suggestion: 'Automated suggestion',
    error_Duration: 'Error Duration',
    jobdetail_processing_time: 'Processing Time',
    job_start_time: 'Start time',
    job_end_time: 'End time',
    add_customer_user_id: 'User name (for Customer login)',
    add_customer_email_address: 'Customer contact e-mail address',
    change_date_heading_day: 'Date selector',
    no_log: 'Dashboard Op-Analysis logs are not sent to CSRA/CSRC',
    unused_log: 'Dashboard Op-Analysis logs are not included in CSRA/CSRC logs',
    datetime_format: 'DD.MM.YY HH:mm:ss',
    header_jobs: 'Jobs',
    no_rows_label: 'No data',
    date_format3: 'DD.MM HH:mm',
    aqa_main_reason_fd_k: 'Vertical streak K',
    aqa_main_reason_fd_c: 'Vertical streak C',
    aqa_main_reason_fd_m: 'Vertical streak M',
    aqa_main_reason_fd_y: 'Vertical streak Y',
    aqa_main_reason_cd_k: 'Horizontal streak K',
    aqa_main_reason_cd_c: 'Horizontal streak C',
    aqa_main_reason_cd_m: 'Horizontal streak M',
    aqa_main_reason_cd_y: 'Horizontal streak Y',
    aqa_main_reason_dba_k: 'Uneven density K',
    aqa_main_reason_dba_c: 'Uneven density C',
    aqa_main_reason_dba_m: 'Uneven density M',
    aqa_main_reason_dba_y: 'Uneven density Y',
    aqa_main_reason_spot_k: 'Spot K',
    aqa_main_reason_spot_c: 'Spot C',
    aqa_main_reason_spot_m: 'Spot M',
    aqa_main_reason_spot_y: 'Spot Y',
    aqa_main_reason_backside_stain: 'Stain',
    machine_detail_timeline: 'Machine Detail Timeline',
    machine_detail_score_transition: 'Image total score transition',
    machine_detail_score_details: 'Diagnostic score details',
    machine_detail_diagnostic_history: 'DIAGNOSTIC HISTORY (Simple/Detailed)',
    machine_detail_dba_history: 'Maximum density transition',
    aqa_score_trend: 'Score',
    aqa_score_average_28days_trend: 'Trend (28 days average)',
    day_time: 'Date time',
    machine_id: 'MachineID',
    overall_score: 'Overall Score',
    main_factors: 'Main factors',
    machine_detail_score: 'Comprehensive image score',
    machine_detail_score_last_date: 'Latest date',
    machine_detail_score_last_num: 'Latest score',
    machine_detail_score_average_num: 'Historical average score',
    machine_detail_score_major_factor: 'Main factor',
    machine_detail_score_last: 'Latest score:',
    machine_detail_score_average_28days: '28 days average score:',
    aqa_diagnostic_score_legend_error: 'Error',
    aqa_diagnostic_score_legend_warning: 'Warning',
    aqa_diagnostic_score_legend_ok: 'OK',
    aqa_diagnostic_score_subtitle: 'Diagnostic Item',
    aqa_color: 'Color',
    aqa_fd_streak_rank: 'Vertical streak',
    aqa_cd_streak_rank: 'Horizontal streak',
    aqa_cd_banding_rank	: 'CD Banding',
    aqa_blurry_white_spot: 'White spot noise',
    aqa_blurry_color_spot: 'Color spot noise',
    aqa_white_spot: 'White speckle',
    aqa_black_spot: 'Black speckle',
    aqa_inky_backside: 'Stain',
    aqa_uneven_density: 'Uneven density',
    aqa_dba_adapt: '(Adjusted)',
    aqa_quality_information: 'Display AQA Quality Information',
    ce_sn_validation: 'Serial number should be 13 characters for KM printer',
    aqa_history_table_title: 'Image diagnosis (Simple/Detailed)',
    date_format4: 'DD.MM.YY HH:mm',
    header_group_AccurioLabel: 'AccurioLabel',
    header_group_registered_mixed_error: 'Web-fed machine can\'t be registered mixed with sheet-fed machine',
    label_machine_printed_length: 'Print length',
    label_machine_printed_length_with_unit: 'Print length(m)',
    label_machine_act_printed_length_with_unit: 'Act. Print length(m)',
    label_machine_printed_length_unit: 'm',
    label_machine_printed_length_time_unit: 'm/hour',
    label_machine_printed_length_with_unit2: 'Length/Set',
    label_machine_top_operator_subtitle_printed_length_result: 'Trend of print length',
    label_machine_top_operator_act_printed_length: 'Act. Print length',
    label_machine_screen_sheets_per_h: '#of prints(m/hour)',
    label_machine_joblist_est_hourlyunits: 'Pred. Print length(m/hour)',
    label_machine_joblist_act_hourlyunits: 'Act. Print length(m/hour)',
    header_machine_setting_remove_group_confirmation: 'Are you sure you want to remove this group "{group}"?',
    machinedetail_passed_day: '(Last 7 Days)',
    machinedetail_passed_week: '(Last 4 Weeks)',
    machinedetail_passed_month: '(Last 4 Months)',
    label_machine_waste_paper_length: 'Waste paper length',
    change_disabled_date_heading: 'Range',
    change_disabled_date_explanation: 'The duration of the CSV export',
    ce_edit_transportLog: 'Transport Log',
    ce_edit_transportLog_dialog_title: 'Transport Log Setting',
    ce_edit_transportLog_dialog_no: 'No.',
    ce_edit_transportLog_dialog_dev_env: 'Transport dev',
    ce_edit_transportLog_dialog_dev_stag: 'Transport sam',
    current_page: 'Current page:',
    total_pages: 'Total Pages:',
    ds_version_title: 'Version',
    ds_version_oss: 'Disclosure of OSS information',
    ds_dashboard_version: 'KONICA MINOLTA AccurioPro Dashboard CE Version',
    ds_version_ds_num: '1.4.3',
    ds_version_copyright: 'Copyright(C)2022',
    ds_version_companyName: 'KONICA MINOLTA.INC.',
    ds_import_cancle_btn: 'Close',
    header_settingMenu_version: 'Version',
    ce_application_sub_title: 'For Customer Engineers',
    ce_authorizer: 'Approver Email Address',
    ce_addCustomers_JMAndAQA_title : "Both JobManager and Op-Analysis",
    ce_addCustomers_ScheduleJM_title : "New JobManager",
    ce_addCustomers_Schedule_switch_label :"Scheduling feature",
    ce_addCustomers_flux_switch_label : "FLUX Integration Feature",
    ce_editCustomers_flux_endpoint_url: "Copy the endpoint URL to the clipboard",
    ce_request_subTitle: "Customer Info",
    ce_request_header_date : "request date", 
    ce_request_header_contents : "contents",
    ce_header_link_request : "request confirm",
    ce_edit_email_button: 'edit',
};
export default en;
